import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Alert } from 'reactstrap';
import { parse } from 'date-fns';
import { useParams } from 'react-router-dom';
import queryString from 'query-string';
import { startCase } from 'lodash';

import {
  utilsInstance as axios,
  baseInstance as base,
} from '~/utils';

import Identity from '~/assets/identity.svg';
import Bg from '~/assets/bg-login.png';

const useQuery = () => queryString.parse(window.location.search);

const StyledPage = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  &.bg-full {
    background-image: url("${Bg}");
  }

  .p-splash__inner {
    position: relative;
    height: 100%;
    background-color: rgba(0,0,0,.4);

    @media (min-width: 768px) {
      /* magic numbers */
      left: 70px;
      width: 500px;
      background-color: rgba(0,0,0,.6);
    }

    .p-form__container {
      position: absolute;
      top: 40%;
      right: 1rem;
      left: 1rem;
      transform: translateY(-40%);

      @media (min-width: 576px) {
        top: 50%;
        right: 100px;
        left: 100px;
        transform: translateY(-50%);
      }
    }
  }
`;

const Splash = ({ children }) => {
  const [version, setVersion] = useState({});
  const [alerts, setAlerts] = useState([]);
  const [apiVersion, setApiVersion] = useState({});
  const params = useParams();
  const { o } = useQuery();
  const [organization] = useState(o || params.organization);

  useEffect(() => {
    fetch('/version.json')
      .then(r => r.json())
      .then((r) => {
        console.table(r);
        setVersion(r);
      });

    axios
      .get(`/alerts?date=${parse(new Date()).toISOString()}&is_active=true`)
      .then(r => r.data.data)
      .then(r => setAlerts(r));

    base
      .get('/version')
      .then(r => r.data)
      .then((r) => {
        console.table(r);
        setApiVersion(r);
      });
  }, []);

  return (
    <StyledPage className="bg-full">
      <div className="p-splash__inner">
        <div className="p-form__container">
          <h1 className="text-white text-center">
            <img src={organization ? `https://s3.amazonaws.com/cordata-global-assets/logo-${organization}.svg` : Identity} width={300} alt={startCase(organization)} className="mb-3 mr-2" />
          </h1>

          {!!alerts.length && alerts.map(a =>
            <Alert color={a.attributes.level}>{a.attributes.message}</Alert>)}

          {children}

          <p className="text-right text-muted pt-3">
            {version.version && (`web: ${version.version}`)}<br />
            {apiVersion.version && (`api: ${apiVersion.version}`)}
          </p>
        </div>
      </div>
    </StyledPage>
  );
};

Splash.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Splash;
